export const STORAGE_KEYS = {
    userToken: "user-token",
    expiredTokenTime: "expired-token-time",
    lastRequest: "last-date-req",
    authHeader:"Auth-Sq"
  } as const;
  